<template>
  <section>
    <social-header title="商品列表"></social-header>
    <!--头部-->
    <div class="product" id="product-list">
      <div class="product-col" v-for="(item,key) in products" :key="key">
        <router-link :to="{path:'/product/detail/'+item.id}" v-stat:click="{name:'activity_detail_wholeArea', actid:item.id}">
          <h3>
            <span v-if="item.top==1">置顶</span>{{item.name}}</h3>
          <div class="product-col-box clearfix">
            <div class="product-col-img">
              <img :src="item.img" alt="">
            </div>
            <div class="product-col-con">
              <ul>
                <li>售价：¥{{item.promotionPrice}}元</li>
                <li>预计奖励：
                  <span class="font-red">¥{{item.agentCommission}}元</span>
                </li>
              </ul>
            </div>
          </div>
        </router-link>
        <router-link :to="{path:'/product/detail/'+item.id}" v-stat:click="{name:'activity_detail_btn', actid:item.id}" class="share-btn" title="" style="letter-spacing:0;">查看详情</router-link>
      </div>
    </div>
    <pull-load target-element="product-list" v-bind:bottom-method="loadMoreProduct" v-bind:state="loadMoreState"></pull-load>
    <social-dialog title="正在加载" category="tips" v-bind:show="dialogShow"></social-dialog>
  </section>
</template>

<script>
import {
  mapGetters
} from 'vuex'
import SocialHeader from '../../components/social-header.vue'
import SocialDialog from '../../components/social-dialog.vue'
import PullLoad from '../../components/pull-load.vue'
import Tools from '../../tools/tools.js'

export default {
  components: {
    SocialHeader,
    SocialDialog,
    PullLoad
  },
  name: 'ProductList',
  data: function () {
    return {
      isLoadingProduct: true,
      loadMoreState: 0
    }
  },
  created: function () {
    this.cheackUserAccountState()
    this.isLoadingProduct = true
    let cityId = this.$store.getters.userCity.cityId
    let pvAreaId = Tools.getQueryString('pvareaId')
    if (!pvAreaId) {
      pvAreaId = '0'
    }
    let that = this
    this.$store.dispatch('getProductList', { cityId, pvAreaId }).then(function () {
      that.isLoadingProduct = false
    })
  },
  computed: {
    dialogShow () {
      return this.isLoadingProduct
    },
    cityId () {
      return this.userCity.cityId
    },
    ...mapGetters({
      products: 'products',
      userCity: 'userCity',
      userInfo: 'userInfo',
      isProductPageEnd: 'isProductPageEnd'
    })
  },
  methods: {
    // 滚动加载更多
    loadMoreProduct: function () {
      var current = this
      if (current.isProductPageEnd) {
        current.loadMoreState = 2
        return false
      }
      if (current.loadMoreState !== 0) {
        return false
      }
      current.loadMoreState = 1

      current.$store.dispatch('loadMoreProducts').then(function () {
        current.loadMoreState = 0
        if (current.isProductPageEnd) {
          current.loadMoreState = 2
        }
        current.dialogShow = false
      })
    },
    cheackUserAccountState () {
      var self = this
      if (self.userInfo && self.userInfo.accountState === 2) {
        this.$router.replace('/account')
      }
    }
  },
  watch: {
    userInfo: function (val, oldVal) {
      if (val.accountState === 2) {
        this.$router.replace('/account')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/activity/products.vue